import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { de, fr, it, enUS } from 'date-fns/locale';

import en from './locales/en.json';
import de_CH from './locales/de-CH.json';
import fr_CH from './locales/fr-CH.json';
import it_CH from './locales/it-CH.json';

export const dateLocales = {
  en: enUS,
  de: de,
  fr: fr,
  it: it,
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      de: { translation: de_CH },
      fr: { translation: fr_CH },
      it: { translation: it_CH },
    },
    lng: 'de', // Set German as default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;